import React, { useState, useEffect, useRef, useContext } from 'react';
import {
  profileData,
  projectsData,
  experienceData,
  achievementsData,
  skillsData,
  systemCommands,
  fortuneQuotes,
  motdMessages,
  teachingExperience,
  ongoingproj,
  completedprojs
} from '../mock';
import { ThemeContext } from './ThemeProvider';
import GameEngine from './GameEngine';
import './Terminal.css';
//import my resume from public folder
// import resumePDF from '../../public/Ibrahim_Farrukh_Resume.pdf';

const Terminal = () => {
  const [currentPath, setCurrentPath] = useState('/home/ibrahim');
  const [commandHistory, setCommandHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);
  const [input, setInput] = useState('');
  const [activeGame, setActiveGame] = useState(null);
  const [systemStats, setSystemStats] = useState({
    cpuUsage: 0,
    memoryUsage: 0,
    networkActivity: 0
  });

  const initialOutput = [
  { type: 'system', content: '🚀 Welcome to Ibrahim\'s Portfolio Shell OS v2.1.0' },
  { type: 'system', content: '═══════════════════════════════════════════════════' },
  { type: 'output', content: 'Interactive Features Enabled:' },
  { type: 'tip', content: '💡 Press TAB for intelligent auto-completion' },
  { type: 'tip', content: '💡 Use ↑↓ arrows for command history navigation' },
  { type: 'tip', content: '💡 Press ESC to clear current input' },
  { type: 'output', content: '' },
  { type: 'hint', content: 'Quick Start: Try "help", "whoami", or "theme matrix"' },
  { type: 'output', content: '' }
];
  const [output, setOutput] = useState(initialOutput);

  const inputRef = useRef(null);
  const terminalRef = useRef(null);
  const { changeTheme, getThemeList, currentTheme } = useContext(ThemeContext);

  useEffect(() => {
    // Auto-focus input
    if (inputRef.current) {
      inputRef.current.focus();
    }

    // Initialize session start time
    if (!sessionStorage.getItem('shellStartTime')) {
      sessionStorage.setItem('shellStartTime', Date.now().toString());
    }

    // Update system stats periodically
    const statsInterval = setInterval(() => {
      setSystemStats(prev => ({
        cpuUsage: Math.max(5, Math.min(95, prev.cpuUsage + (Math.random() - 0.5) * 10)),
        memoryUsage: Math.max(20, Math.min(90, prev.memoryUsage + (Math.random() - 0.5) * 5)),
        networkActivity: Math.floor(Math.random() * 150)
      }));
    }, 3000);

    return () => clearInterval(statsInterval);
  }, []);

  useEffect(() => {
    // Auto-scroll to bottom
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [output]);

  const processCommand = (command) => {
    const trimmed = command.trim();
    const parts = trimmed.split(' ');
    const cmd = parts[0].toLowerCase();
    const args = parts.slice(1);

    // Add command to history
    if (trimmed) {
      setCommandHistory(prev => [...prev, trimmed]);
      setHistoryIndex(-1);
    }

    // Add command to output
    addOutput('command', `${currentPath}$ ${command}`);

    // Process command
    switch (cmd) {
      case 'help':
        handleHelp(args[0]);
        break;
      case 'ls':
      case 'dir':
        handleLs(args[0]);
        break;
      case 'cd':
        handleCd(args[0]);
        break;
      case 'pwd':
        addOutput('output', currentPath);
        break;
      case 'cat':
      case 'type':
      case 'more':
        handleCat(args[0]);
        break;
      case 'clear':
      case 'cls':
        handleClear();
        break;
      case 'whoami':
        handleWhoami();
        break;
      case 'theme':
        handleTheme(args[0]);
        break;
      case 'fortune':
        handleFortune();
        break;
      case 'motd':
        handleMotd();
        break;
      case 'ascii':
        handleAscii(args.join(' '));
        break;
      case 'nano':
      case 'edit':
        handleNano(args[0]);
        break;
      case 'sudo':
        handleSudo(args.join(' '));
        break;
      case 'games':
        handleGames();
        break;
      case 'play':
        handlePlayGame(args[0]);
        break;
      case 'showcase':
        handleThemeShowcase();
        break;
      case 'matrix':
        handleMatrixMode();
        break;
      case 'weather':
        handleWeather(args[0]);
        break;
      case 'crypto':
        handleCrypto(args[0]);
        break;
      case 'music':
        handleMusic(args[0]);
        break;
      case 'social':
        handleSocialStats();
        break;
      case 'monitor':
        handleSystemMonitor();
        break;
      case 'alias':
        handleAlias(args[0], args[1]);
        break;
      case 'execute':
      case 'run':
        handleCodeExecution(args.join(' '));
        break;
      case 'ai':
      case 'chat':
        handleAIAssistant(args.join(' '));
        break;
      case 'history':
        handleHistory();
        break;
      case 'exit':
      case 'quit':
        handleExit();
        break;
      case 'date':
        handleDate();
        break;
      case 'uptime':
        handleUptime();
        break;
      case 'tree':
        handleTree();
        break;
      case 'find':
        handleFind(args[0]);
        break;
      case 'grep':
        handleGrep(args.join(' '));
        break;
      case 'man':
        handleMan(args[0]);
        break;
      case 'info':
        handleInfo();
        break;
      case 'download':
        handleDownload(args[0]);
        break;
      case '':
        break;
      default:
        handleUnknownCommand(cmd);
    }
  };

  const addOutput = (type, content) => {
    setOutput(prev => [...prev, { type, content }]);
  };

  const fetchGitHubStats = async () => {
    try {
      const res = await fetch("https://api.github.com/users/fireblaster000/repos");
      const repos = await res.json();
      profileData.githubRepos = repos.length; // number of public repos
    } catch (err) {
      console.error("GitHub API Error:", err);
    }
  };

//   const fetchProfileViews = async () => {
//   try {
//     const res = await fetch(
//       "https://counterapi.dev/v2/muhammad-ibrahim-farrukh/up/pageviewssss"
//     );
//     const data = await res.json();
//     console.log("CounterAPI Data:", data);
//     profileData.totalViews = data.value; // auto increments & returns total
//   } catch (err) {
//     console.error("CounterAPI Error:", err);
//     profileData.totalViews = "N/A";
//   }
// };

const fetchProfileViews = async () => {
  try {
    // Construct URL with API key as a query parameter
    const apiUrl = `https://api.counterapi.dev/v2/${process.env.REACT_APP_COUNTER_WORKSPACE}/${process.env.REACT_APP_COUNTER_NAME}/up?apikey=${process.env.REACT_APP_COUNTER_API_KEY}`;

    const res = await fetch(apiUrl, {
      method: "GET",
    });

    if (!res.ok) {
      throw new Error(`Counter API returned status ${res.status}`);
    }

    const data = await res.json();
    console.log("Counter API Response:", data);

    // Update profile data
    profileData.totalViews = data.data.up_count;
    console.log("Profile views:", profileData.totalViews);

    return profileData.totalViews;
  } catch (err) {
    console.error("Counter API Error:", err);
  }
};







  const handleHelp = (specificCommand) => {
    if (specificCommand) {
      const cmd = systemCommands[specificCommand.toLowerCase()];
      if (cmd) {
        addOutput('help-header', `=== ${specificCommand.toUpperCase()} COMMAND HELP ===`);
        addOutput('output', `Description: ${cmd.description}`);
        addOutput('output', `Usage: ${cmd.usage}`);
        if (cmd.example) {
          addOutput('example', `Example: ${cmd.example}`);
        }
        if (cmd.aliases) {
          addOutput('output', `Aliases: ${cmd.aliases.join(', ')}`);
        }
        if (cmd.options) {
          addOutput('output', 'Options:');
          cmd.options.forEach(opt => {
            addOutput('output', `  ${opt.flag.padEnd(12)} - ${opt.description}`);
          });
        }
        if (cmd.notes) {
          addOutput('note', `💡 Note: ${cmd.notes}`);
        }
      } else {
        addOutput('error', `No help available for: ${specificCommand}`);
        addOutput('hint', 'Use "help" to see all available commands');
      }
    } else {
      addOutput('help-header', '=== IBRAHIM\'S PORTFOLIO SHELL OS - COMMAND REFERENCE ===');
      addOutput('output', '');

      // Navigation Commands
      addOutput('section', '📁 NAVIGATION & FILE OPERATIONS:');
      addOutput('output', '  ls, dir         - List directory contents');
      addOutput('output', '  cd <directory>  - Change to directory (try: cd /projects)');
      addOutput('output', '  pwd             - Show current directory path');
      addOutput('output', '  cat <file>      - Display file contents (try: cat about.txt)');
      addOutput('output', '  tree            - Show directory structure');
      addOutput('output', '  find <term>     - Search for files and content');
      addOutput('output', '');

      // System Commands
      addOutput('section', '🖥️ SYSTEM & INFO COMMANDS:');
      addOutput('output', '  whoami          - Display user information');
      addOutput('output', '  info            - Show system information');
      addOutput('output', '  date            - Show current date and time');
      addOutput('output', '  uptime          - Show system uptime');
      addOutput('output', '  history         - Show command history');
      addOutput('output', '');

      // Customization Commands
      addOutput('section', '🎨 CUSTOMIZATION & THEMES:');
      addOutput('output', '  theme <name>    - Switch visual themes (12 artistic options)');
      addOutput('output', '  showcase        - Display all available artistic themes');
      addOutput('output', '  clear, cls      - Clear terminal screen');
      addOutput('output', '');

      // Fun Commands
      addOutput('section', '🎯 FUN & INTERACTIVE:');
      addOutput('output', '  play <game>     - Launch interactive games (snake, pong, typing, memory)');
      addOutput('output', '  matrix          - Enter matrix mode with digital rain');
      addOutput('output', '  fortune         - Display random quote');
      addOutput('output', '  ascii <text>    - Generate ASCII art');
      addOutput('output', '  motd            - Message of the day');
      addOutput('output', '');

      // Professional Commands
      addOutput('section', '💼 PROFESSIONAL & PRODUCTIVITY:');
      // addOutput('output', '  nano resume.txt - Open resume in editor');
      addOutput('output', '  download cv     - Download resume/CV');
      // addOutput('output', '  weather <city>  - Check weather conditions');
      // addOutput('output', '  crypto <coin>   - View cryptocurrency prices');
      addOutput('output', '  social          - Social media analytics');
      addOutput('output', '  monitor         - Real-time system monitoring');
      addOutput('output', '  sudo hire ibrahim - Initiate hiring process 😉');
      addOutput('output', '');

      // Advanced & AI Features
      addOutput('section', '🤖 AI & ADVANCED FEATURES:');
      addOutput('output', '  ai <question>   - Chat with AI coding assistant');
      // addOutput('output', '  execute <code>  - Run Python code simulator');
      // addOutput('output', '  music <action>  - Control coding soundtrack');
      addOutput('output', '  alias <name> <cmd> - Create command shortcuts');
      addOutput('output', '');

      // Advanced Usage
      addOutput('section', '🔧 ADVANCED USAGE:');
      addOutput('tip', '💡 Use TAB for auto-completion');
      addOutput('tip', '💡 Use ↑↓ arrow keys for command history');
      addOutput('tip', '💡 Try "man <command>" for detailed manual pages');
      addOutput('tip', '💡 Type partial command + TAB to see suggestions');
      addOutput('output', '');

      // Easter Eggs Hint
      addOutput('section', '🥚 EASTER EGGS:');
      addOutput('hint', 'Try: "sudo rm -rf /", "sudo make coffee", "grep -r love ."');
      addOutput('output', '');
      addOutput('output', 'Type "help <command>" for detailed information about any command.');
    }
  };

  const handleClear = () => {
    setOutput(initialOutput);
    // addOutput('system', 'Terminal cleared. Welcome back to Ibrahim\'s Portfolio Shell!');
    // addOutput('hint', 'Type "help" for available commands or "motd" for inspiration.');
  };

  const handleHistory = () => {
    if (commandHistory.length === 0) {
      addOutput('output', 'No commands in history yet.');
      addOutput('hint', 'Start typing commands to build your history!');
      return;
    }

    addOutput('output', 'Command History:');
    commandHistory.forEach((cmd, index) => {
      addOutput('output', `  ${(index + 1).toString().padStart(3, ' ')}  ${cmd}`);
    });
    addOutput('output', '');
    addOutput('tip', '💡 Use ↑↓ arrow keys to navigate history');
  };

  const handleExit = () => {
    addOutput('output', 'Thanks for visiting Ibrahim\'s Portfolio Shell!');
    addOutput('system', 'To restart, simply refresh the page.');
    addOutput('output', '👋 See you soon!');
  };

  const handleDate = () => {
    const now = new Date();
    const formatted = now.toLocaleString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'short'
    });
    addOutput('output', formatted);
    addOutput('output', `Unix timestamp: ${Math.floor(now.getTime() / 1000)}`);
  };

  const handleUptime = () => {
    const startTime = sessionStorage.getItem('shellStartTime') || Date.now();
    const uptime = Date.now() - startTime;
    const minutes = Math.floor(uptime / 60000);
    const seconds = Math.floor((uptime % 60000) / 1000);

    addOutput('output', `Portfolio Shell uptime: ${minutes}m ${seconds}s`);
    addOutput('output', `Session started: ${new Date(parseInt(startTime)).toLocaleTimeString()}`);
    addOutput('output', `Commands executed: ${commandHistory.length}`);
  };

  const handleTree = () => {
    addOutput('output', 'Directory Structure:');
    addOutput('tree', '/home/ibrahim/');
    addOutput('tree', '├── about/');
    addOutput('tree', '│   └── bio.txt');
    addOutput('tree', '│   └── story.md');
    addOutput('tree', '│   └── education.txt');
    addOutput('tree', '│   └── philosophy.txt');
    addOutput('tree', '│   └── interests.json');
    addOutput('tree', '├── projects/');
    addOutput('tree', '│   ├── ongoing.md');
    addOutput('tree', '│   ├── completed.md');
    // addOutput('tree', '│   ├── AI Industry Pulse/');
    // addOutput('tree', '│   ├── Solver Sphere/');
    // addOutput('tree', '│   ├── Fantasy Premier League AI Coach and ML Predictor/');
    // addOutput('tree', '│   └── Trading Platform/');
    addOutput('tree', '├── experience/');
    addOutput('tree', '│   └── work_research_timeline.json');
    addOutput('tree', '│   └── recommendations.md');
    addOutput('tree', '│   └── skills_growth.json');
    addOutput('tree', '│   └── teaching.json');
    addOutput('tree', '├── achievements/');
    // addOutput('tree', '│   ├── publications.md');
    addOutput('tree', '│   └── awards.json');
    addOutput('tree', '│   └── highlights.md');
    addOutput('tree', '└── contact/');
    addOutput('tree', '    ├── email.txt');
    addOutput('tree', '    └── social_links.json');
    addOutput('tree', '    └── phone.txt');
    addOutput('tree', '    └── website.url');
    addOutput('tree', '    └── location.txt');

  };

  const handleFind = (term) => {
    if (!term) {
      addOutput('error', 'Usage: find <search_term>');
      addOutput('example', 'Example: find "machine learning"');
      return;
    }

    const results = [];
    const searchTerm = term.toLowerCase();

    // Search in projects
    Object.entries(projectsData).forEach(([key, project]) => {
      if (project.name.toLowerCase().includes(searchTerm) ||
        project.description.toLowerCase().includes(searchTerm) ||
        project.tech.some(t => t.toLowerCase().includes(searchTerm))) {
        results.push(`/projects/${key} - ${project.name}`);
      }
    });

    // Search in skills
    Object.entries(skillsData).forEach(([category, skills]) => {
      skills.forEach(skill => {
        if (skill.toLowerCase().includes(searchTerm)) {
          results.push(`/skills/${category.toLowerCase()} - ${skill}`);
        }
      });
    });

    // Search in achievements
    achievementsData.forEach((achievement, index) => {
      if (achievement.title.toLowerCase().includes(searchTerm) ||
        achievement.description.toLowerCase().includes(searchTerm)) {
        results.push(`/achievements/${index} - ${achievement.title}`);
      }
    });

    if (results.length > 0) {
      addOutput('output', `Found ${results.length} matches for "${term}":`);
      results.forEach(result => addOutput('output', `  ${result}`));
    } else {
      addOutput('output', `No results found for "${term}"`);
      addOutput('hint', 'Try searching for: "ml", "python", "research", or "ai"');
    }
  };

  const handleGrep = (pattern) => {
    if (!pattern) {
      addOutput('error', 'Usage: grep <pattern>');
      addOutput('example', 'Example: grep "love coding"');
      return;
    }

    // Easter egg responses for fun patterns
    if (pattern.includes('love')) {
      addOutput('output', 'Found matches in /home/ibrahim/thoughts.txt:');
      addOutput('output', '  ❤️  I love building innovative ML solutions');
      addOutput('output', '  ❤️  I love the challenge of complex algorithms');
      addOutput('output', '  ❤️  I love contributing to open source');
    } else if (pattern.includes('coffee')) {
      addOutput('output', 'Found matches in /home/ibrahim/.bashrc:');
      addOutput('output', '  ☕ alias work="coffee && code"');
      addOutput('output', '  ☕ # Coffee is the fuel of innovation');
    } else {
      addOutput('output', `Searching for pattern: ${pattern}`);
      addOutput('output', 'Search complete. No matches found in current directory.');
      addOutput('hint', 'Try: grep "love" or grep "coffee" for fun results!');
    }
  };

  const handleMan = (command) => {
    if (!command) {
      addOutput('error', 'Usage: man <command>');
      addOutput('example', 'Example: man ls');
      return;
    }

    const manPages = {
      ls: {
        name: 'ls - list directory contents',
        synopsis: 'ls [DIRECTORY]',
        description: 'List information about files and directories. If no directory is specified, lists contents of current directory.',
        options: [
          '-l    Use long listing format (coming soon)',
          '-a    Show hidden files (coming soon)',
          '-h    Human readable sizes (coming soon)'
        ],
        examples: [
          'ls              # List current directory',
          'ls /projects    # List projects directory',
          'ls /            # List root directory'
        ]
      },
      cat: {
        name: 'cat - display file contents',
        synopsis: 'cat <file>',
        description: 'Display the contents of a file in the terminal.',
        examples: [
          'cat about.txt       # Show about information',
          'cat resume.txt      # Display resume',
          'cat project.md      # Show project details'
        ]
      },
      theme: {
        name: 'theme - change visual appearance',
        synopsis: 'theme [THEME_NAME]',
        description: 'Change the visual theme of the terminal and interface.',
        examples: [
          'theme              # List available themes',
          'theme matrix       # Switch to Matrix theme',
          'theme cyberpunk    # Switch to Cyberpunk theme'
        ]
      }
    };

    const page = manPages[command.toLowerCase()];
    if (page) {
      addOutput('man-header', `${page.name.toUpperCase()}`);
      addOutput('output', '');
      addOutput('man-section', 'SYNOPSIS');
      addOutput('output', `    ${page.synopsis}`);
      addOutput('output', '');
      addOutput('man-section', 'DESCRIPTION');
      addOutput('output', `    ${page.description}`);

      if (page.options) {
        addOutput('output', '');
        addOutput('man-section', 'OPTIONS');
        page.options.forEach(opt => addOutput('output', `    ${opt}`));
      }

      addOutput('output', '');
      addOutput('man-section', 'EXAMPLES');
      page.examples.forEach(ex => addOutput('output', `    ${ex}`));

      addOutput('output', '');
      addOutput('man-footer', 'Ibrahim\'s Portfolio Shell OS                    2024');
    } else {
      addOutput('error', `No manual entry for ${command}`);
      addOutput('hint', 'Available manual pages: ls, cat, theme');
    }
  };

  // const handleInfo = () => {
  //   addOutput('system-info', '=== SYSTEM INFORMATION ===');
  //   addOutput('output', '');
  //   addOutput('output', `User: ${profileData.name}`);
  //   addOutput('output', `Role: ${profileData.tagline}`);
  //   addOutput('output', `System: Portfolio Shell OS v2.1.0`);
  //   addOutput('output', `Kernel: ReactJS 19.0.0`);
  //   addOutput('output', `Shell: /bin/ibrahim-shell`);
  //   addOutput('output', `Architecture: Full-Stack x86_64`);
  //   addOutput('output', `Current Theme: ${currentTheme}`);
  //   addOutput('output', `Available Themes: ${getThemeList().length}`);
  //   addOutput('output', `Total Projects: ${Object.keys(projectsData).length}`);
  //   addOutput('output', `GitHub Streak: ${profileData.githubStreak}`);
  //   addOutput('output', `Total Commits: ${profileData.totalCommits}`);
  //   addOutput('output', '');
  //   addOutput('output', `Status: ${profileData.currentStatus}`);
  // };
  const handleInfo = async () => {
  await fetchGitHubStats();
  await fetchProfileViews();

  const totalProjects = Object.keys(ongoingproj).length + Object.keys(completedprojs).length;

  addOutput('system-info', '=== SYSTEM INFORMATION ===');
  addOutput('output', '');
  addOutput('output', `User: ${profileData.name}`);
  addOutput('output', `Role: ${profileData.tagline}`);
  addOutput('output', `System: Portfolio Shell OS v2.1.0`);
  addOutput('output', `Kernel: ReactJS 19.0.0`);
  addOutput('output', `Shell: /bin/ibrahim-shell`);
  addOutput('output', `Architecture: Full-Stack x86_64`);
  addOutput('output', `Current Theme: ${currentTheme}`);
  addOutput('output', `Available Themes: ${getThemeList().length}`);
  addOutput('output', `Total Projects: ${totalProjects}`);
  addOutput('output', `GitHub Repos: ${profileData.githubRepos}`);
  // addOutput('output', `Total Commits: ${profileData.totalCommits}`);
  addOutput('output', `Profile Views: 👀 ${profileData.totalViews}`);
  addOutput('output', '');
  addOutput('output', `Status: ${profileData.currentStatus}`);
};


//   const handleDownload = (item) => {
//     if (!item) {
//       addOutput('error', 'Usage: download <item>');
//       addOutput('output', 'Available downloads:');
//       addOutput('output', '  cv, resume    - Download resume/CV');
//       addOutput('output', '  projects      - Download projects portfolio');
//       addOutput('output', '  contact       - Download contact information');
//       return;
//     }

//     switch (item.toLowerCase()) {
//       case 'cv':
//       case 'resume':
//         addOutput('success', 'Preparing resume download...');
//         addOutput('output', '📄 Generating PDF resume...');
//         addOutput('output', '✅ Resume ready for download!');
//         // Simulate download
//         setTimeout(() => {
//           const resumeContent = `
// MUHAMMAD IBRAHIM FARRUKH
// Applied ML Engineer | LLMs Research

// Contact: ${profileData.email}
// GitHub: ${profileData.github}
// LinkedIn: ${profileData.linkedin}

// EXPERIENCE:
// ${experienceData.map(exp => `
// ${exp.title} @ ${exp.company} (${exp.period})
// ${exp.description}
// `).join('')}

// SKILLS:
// ${Object.entries(skillsData).map(([category, skills]) =>
//             `${category}: ${skills.join(', ')}`
//           ).join('\n')}
//           `.trim();

//           const blob = new Blob([resumeContent], { type: 'text/plain' });
//           const url = URL.createObjectURL(blob);
//           const a = document.createElement('a');
//           a.href = url;
//           a.download = 'Ibrahim_Farrukh_Resume.txt';
//           a.click();
//           URL.revokeObjectURL(url);
//         }, 1000);
//         break;

//       case 'projects':
//         addOutput('success', 'Preparing projects portfolio...');
//         addOutput('output', '📁 Compiling project details...');
//         addOutput('output', '✅ Projects portfolio ready!');
//         break;

//       case 'contact':
//         addOutput('success', 'Preparing contact information...');
//         addOutput('output', `📧 Email: ${profileData.email}`);
//         addOutput('output', `🔗 GitHub: ${profileData.github}`);
//         addOutput('output', `💼 LinkedIn: ${profileData.linkedin}`);
//         break;

//       default:
//         addOutput('error', `Unknown download item: ${item}`);
//         addOutput('hint', 'Try: download cv, download projects, or download contact');
//     }
//   };

const handleDownload = (item) => {
  if (!item) {
    addOutput('error', 'Usage: download <item>');
    addOutput('output', 'Available downloads:');
    addOutput('output', '  cv, resume    - Download resume/CV');
    addOutput('output', '  projects      - Download projects portfolio');
    addOutput('output', '  contact       - Download contact information');
    return;
  }

  switch (item.toLowerCase()) {
    case 'cv':
    case 'resume':
      addOutput('success', 'Preparing resume download...');
      addOutput('output', '📄 Fetching PDF resume...');

      setTimeout(async () => {
        try {
          const resumePath = '/IbrahimFarrukh_resume.pdf'; // should be inside /public/

          const a = document.createElement('a');
          a.href = resumePath;
          a.download = 'Ibrahim_Farrukh_Resume.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          addOutput('output', '✅ Resume ready for download!');
        } catch (err) {
          addOutput('error', '❌ Resume file not found. Please make sure Ibrahim_Farrukh_Resume.pdf is in the /public folder.');
        }
      }, 1000);
      break;

    case 'projects':
      addOutput('success', 'Preparing projects portfolio...');
      addOutput('output', '📁 Compiling project details...');
      addOutput('output', '✅ Projects portfolio ready!');
      break;

    case 'contact':
      addOutput('success', 'Preparing contact information...');
      addOutput('output', `📧 Email: ${profileData.email}`);
      addOutput('output', `🔗 GitHub: ${profileData.github}`);
      addOutput('output', `💼 LinkedIn: ${profileData.linkedin}`);
      break;

    default:
      addOutput('error', `Unknown download item: ${item}`);
      addOutput('hint', 'Try: download cv, download projects, or download contact');
  }
};


  const handleUnknownCommand = (cmd) => {
    const suggestions = getCommandSuggestions(cmd);
    addOutput('error', `Command not found: ${cmd}`);

    if (suggestions.length > 0) {
      addOutput('hint', `Did you mean: ${suggestions.join(', ')}?`);
    } else {
      const randomHints = [
        'Type "help" to see all available commands',
        'Try "sudo hire ibrahim" for a surprise 😉',
        'Use TAB for auto-completion',
        'Check out "theme matrix" for a cool effect!'
      ];
      addOutput('hint', randomHints[Math.floor(Math.random() * randomHints.length)]);
    }
  };

  const handlePlayGame = (gameName) => {
    if (!gameName) {
      addOutput('error', 'Usage: play <game-name>');
      addOutput('hint', 'Available games: snake, pong, matrix, typing, memory');
      return;
    }

    const validGames = ['snake', 'pong', 'matrix', 'typing', 'memory'];
    if (validGames.includes(gameName.toLowerCase())) {
      addOutput('success', `🎮 Starting ${gameName} game...`);
      addOutput('game-info', 'Game will open in overlay. Use ESC to exit anytime.');
      setActiveGame(gameName.toLowerCase());
    } else {
      addOutput('error', `Game "${gameName}" not found`);
      addOutput('hint', 'Try: play snake, play pong, play matrix, play typing, or play memory');
    }
  };

  const handleMatrixMode = () => {
    addOutput('matrix-header', '🌧️ ENTERING MATRIX MODE...');
    addOutput('output', '');

    // Generate matrix-style output with real ML/AI terms
    const matrixTerms = [
      'import torch', 'nn.Linear', 'optimizer.step()', 'loss.backward()',
      'model.eval()', 'tensor.cuda()', 'batch_size=32', 'learning_rate=0.001',
      'dropout=0.1', 'attention_heads=8', 'embedding_dim=512', 'vocab_size=50000'
    ];

    for (let i = 0; i < 15; i++) {
      setTimeout(() => {
        const randomTerms = Array.from({ length: 8 }, () =>
          matrixTerms[Math.floor(Math.random() * matrixTerms.length)]
        );
        addOutput('matrix-rain', randomTerms.join('  '));
      }, i * 100);
    }

    setTimeout(() => {
      addOutput('matrix-message', '>>> HIDDEN MESSAGE DECODED: "THE FUTURE IS MACHINE LEARNING" <<<');
      addOutput('success', 'Matrix mode complete. Reality restored.');
    }, 2000);
  };

  const handleWeather = (location = 'Current Location') => {
    addOutput('weather-header', `🌤️ WEATHER DATA FOR ${location.toUpperCase()}`);
    addOutput('output', '');

    // Mock weather data with coding-themed descriptions
    const weatherConditions = [
      { temp: 72, condition: 'Sunny', description: 'Perfect coding weather ☀️' },
      { temp: 68, condition: 'Cloudy', description: 'Great for indoor development ☁️' },
      { temp: 75, condition: 'Partly Cloudy', description: 'Ideal for debugging 🌤️' },
      { temp: 65, condition: 'Overcast', description: 'Time to focus on ML models 🌫️' }
    ];

    const weather = weatherConditions[Math.floor(Math.random() * weatherConditions.length)];

    addOutput('weather-data', `Temperature: ${weather.temp}°F`);
    addOutput('weather-data', `Condition: ${weather.condition}`);
    addOutput('weather-data', `Dev Forecast: ${weather.description}`);
    addOutput('output', '');
    addOutput('weather-suggestion', '💡 Weather-based productivity tip:');
    if (weather.temp > 70) {
      addOutput('tip', 'Great weather for outdoor coding sessions or walking meetings!');
    } else {
      addOutput('tip', 'Perfect indoor weather for deep focus work and code reviews!');
    }
  };

  const handleCrypto = (coin = 'overview') => {
    addOutput('crypto-header', '₿ CRYPTOCURRENCY PRICES');
    addOutput('output', '');

    // Mock crypto data with AI/ML themed coins
    const cryptoData = {
      bitcoin: { price: 67420, change: '+2.5%', symbol: 'BTC' },
      ethereum: { price: 3850, change: '+1.8%', symbol: 'ETH' },
      'ai-token': { price: 0.85, change: '+15.2%', symbol: 'AIT' },
      'ml-coin': { price: 12.45, change: '+8.7%', symbol: 'MLC' },
      'neural-net': { price: 0.0234, change: '+25.1%', symbol: 'NNET' }
    };

    if (coin === 'overview') {
      Object.entries(cryptoData).forEach(([name, data]) => {
        const changeColor = data.change.startsWith('+') ? 'crypto-up' : 'crypto-down';
        addOutput('crypto-price', `${data.symbol.padEnd(6)} $${data.price.toLocaleString().padEnd(12)} ${data.change}`);
      });
    } else if (cryptoData[coin.toLowerCase()]) {
      const data = cryptoData[coin.toLowerCase()];
      addOutput('crypto-detail', `${data.symbol}: $${data.price.toLocaleString()}`);
      addOutput('crypto-detail', `24h Change: ${data.change}`);
    } else {
      addOutput('error', `Cryptocurrency "${coin}" not found`);
      addOutput('hint', 'Available: bitcoin, ethereum, ai-token, ml-coin, neural-net');
    }

    addOutput('output', '');
    addOutput('crypto-disclaimer', '⚠️  Not financial advice. Data for demonstration only.');
  };

  const handleMusic = (action = 'status') => {
    addOutput('music-header', '🎵 CODING SOUNDTRACK PLAYER');
    addOutput('output', '');

    const playlists = [
      'Deep Focus - Ambient Coding',
      'Neural Beats - Electronic ML',
      'Algorithmic Jazz - Complex Rhythms',
      'Binary Chill - Lo-fi Programming',
      'Tensor Flow - Classical for AI'
    ];

    const currentTrack = {
      title: 'Gradient Descent Dreams',
      artist: 'The Neural Networks',
      album: 'Backpropagation Blues',
      duration: '4:32',
      position: '2:18'
    };

    switch (action.toLowerCase()) {
      case 'play':
        addOutput('music-action', '▶️  Now Playing: Programming Productivity Mix');
        addOutput('music-track', `♪ ${currentTrack.title} - ${currentTrack.artist}`);
        break;
      case 'pause':
        addOutput('music-action', '⏸️  Music Paused');
        break;
      case 'playlists':
        addOutput('music-list', 'Available Coding Playlists:');
        playlists.forEach((playlist, index) => {
          addOutput('output', `  ${index + 1}. ${playlist}`);
        });
        break;
      default:
        addOutput('music-status', `Currently Playing: ${currentTrack.title}`);
        addOutput('music-status', `Artist: ${currentTrack.artist}`);
        addOutput('music-status', `Progress: ${currentTrack.position} / ${currentTrack.duration}`);
        addOutput('music-controls', 'Controls: music play | music pause | music playlists');
    }
  };

  const handleSocialStats = () => {
    addOutput('social-header', '📱 SOCIAL MEDIA ANALYTICS');
    addOutput('output', '');

    const socialData = {
      github: { followers: 30, stars: 0, repos: 35 },
      linkedin: { connections: 1000, post_views: 0, profile_views: 2000 },
      // twitter: { followers: 1089, likes: 3400, retweets: 890 },
      // medium: { followers: 234, claps: 1560, articles: 12 }
    };

    Object.entries(socialData).forEach(([platform, stats]) => {
      addOutput('social-platform', `${platform.toUpperCase()}:`);
      Object.entries(stats).forEach(([metric, value]) => {
        addOutput('output', `  ${metric.replace('_', ' ')}: ${value.toLocaleString()}`);
      });
      addOutput('output', '');
    });

    addOutput('social-summary', '📈 Overall Engagement: Growing steadily');
    addOutput('tip', '💡 Best performing content: ML tutorials and code reviews');
  };

  const handleSystemMonitor = () => {
    addOutput('monitor-header', '📊 REAL-TIME SYSTEM MONITOR');
    addOutput('output', '');

    // Simulate real-time system stats
    const updateStats = () => {
      setSystemStats({
        cpuUsage: Math.floor(Math.random() * 40) + 10, // 10-50%
        memoryUsage: Math.floor(Math.random() * 30) + 40, // 40-70%
        networkActivity: Math.floor(Math.random() * 100) // 0-100 MB/s
      });
    };

    updateStats();

    addOutput('monitor-stat', `CPU Usage: ${systemStats.cpuUsage}%`);
    addOutput('monitor-stat', `Memory: ${systemStats.memoryUsage}%`);
    addOutput('monitor-stat', `Network: ${systemStats.networkActivity} MB/s`);
    addOutput('monitor-stat', `Active Processes: ML Training (Python), Portfolio Shell (Node.js), VS Code`);
    addOutput('output', '');

    // Create simple ASCII charts
    const cpuBar = '█'.repeat(Math.floor(systemStats.cpuUsage / 5)) + '░'.repeat(20 - Math.floor(systemStats.cpuUsage / 5));
    const memBar = '█'.repeat(Math.floor(systemStats.memoryUsage / 5)) + '░'.repeat(20 - Math.floor(systemStats.memoryUsage / 5));

    addOutput('monitor-chart', `CPU  [${cpuBar}] ${systemStats.cpuUsage}%`);
    addOutput('monitor-chart', `RAM  [${memBar}] ${systemStats.memoryUsage}%`);

    addOutput('tip', '💡 Use "monitor" again for updated readings');
  };

  const handleAlias = (aliasName, command) => {
    if (!aliasName) {
      addOutput('output', 'Current aliases:');
      addOutput('output', '  ll     -> ls -la');
      addOutput('output', '  ..     -> cd ..');
      addOutput('output', '  gc     -> git commit');
      addOutput('output', '  python -> python3');
      addOutput('output', '  hire   -> sudo hire ibrahim');
      addOutput('example', 'Usage: alias <name> <command>');
      return;
    }

    if (!command) {
      addOutput('error', `Usage: alias ${aliasName} <command>`);
      return;
    }

    addOutput('success', `✅ Alias created: ${aliasName} -> ${command}`);
    addOutput('tip', '💡 Aliases would be saved in a real terminal session');
  };

  const handleCodeExecution = (code) => {
    if (!code) {
      addOutput('error', 'Usage: execute <python_code>');
      addOutput('example', 'Example: execute print("Hello, ML World!")');
      return;
    }

    addOutput('code-header', '🐍 PYTHON CODE EXECUTION SIMULATOR');
    addOutput('code-input', `>>> ${code}`);

    // Simulate code execution with ML-themed responses
    setTimeout(() => {
      if (code.includes('import')) {
        addOutput('code-output', '✅ Modules imported successfully');
      } else if (code.includes('print')) {
        const match = code.match(/print\((.*)\)/);
        if (match) {
          addOutput('code-output', match[1].replace(/["']/g, ''));
        }
      } else if (code.includes('torch') || code.includes('tensorflow')) {
        addOutput('code-output', '🧠 ML framework initialized');
        addOutput('code-output', 'GPU detected: NVIDIA RTX 4090');
      } else {
        addOutput('code-output', '✅ Code executed successfully');
        addOutput('code-output', 'Result: <complex_tensor_computation>');
      }
    }, 500);
  };

  const handleThemeShowcase = () => {
    addOutput('showcase-header', '🎨 ARTISTIC THEME SHOWCASE');
    addOutput('output', '');
    addOutput('output', 'Experience the visual artistry of each theme:');
    addOutput('output', '');

    const showcaseThemes = [
      { name: 'aurora', desc: '🌌 Aurora Borealis - Mystical northern lights dancing' },
      { name: 'neon_synthwave', desc: '🌈 Neon Synthwave - Retro-futuristic 80s aesthetic' },
      { name: 'cosmic_void', desc: '🌠 Cosmic Void - Deep space with swirling cosmic dust' },
      { name: 'digital_forest', desc: '🌲 Digital Forest - Organic code growth patterns' },
      { name: 'cyberpunk_city', desc: '🏙️ Cyberpunk City - Neon-lit metropolis' },
      { name: 'quantum_realm', desc: '⚛️ Quantum Realm - Particle physics visualization' },
      { name: 'neural_network', desc: '🧠 Neural Network - Animated neural connections' },
      { name: 'matrix_reloaded', desc: '💚 Matrix Reloaded - Enhanced flowing cascades' },
      { name: 'sunset_gradient', desc: '🌅 Sunset Gradient - Warm sunset transitions' },
      { name: 'holographic', desc: '✨ Holographic - Iridescent rainbow effects' },
      { name: 'minimal_zen', desc: '🎯 Minimal Zen - Clean minimalist design' },
      { name: 'retro_terminal', desc: '📺 Retro Terminal - Classic amber phosphor display' }
    ];

    showcaseThemes.forEach(theme => {
      addOutput('showcase-theme', theme.desc);
    });

    addOutput('output', '');
    addOutput('showcase-tip', '🎨 Try: theme <name> to switch (e.g., "theme aurora")');
    addOutput('showcase-tip', '⚡ Each theme includes unique animations and effects!');
    addOutput('showcase-tip', '🔄 Use TAB completion for theme names');
  };

  const handleAIAssistant = (query) => {
    if (!query) {
      addOutput('ai-header', '🤖 AI CODING ASSISTANT');
      addOutput('output', '');
      addOutput('output', 'Hello! I\'m Ibrahim\'s AI assistant. I can help with:');
      addOutput('ai-capability', '• Machine Learning questions');
      addOutput('ai-capability', '• Code debugging and optimization');
      addOutput('ai-capability', '• Career advice in AI/ML');
      addOutput('ai-capability', '• Research paper recommendations');
      addOutput('example', 'Usage: ai <your_question>');
      return;
    }

    addOutput('ai-query', `You: ${query}`);
    addOutput('ai-thinking', '🤔 AI thinking...');

    // Simulate AI response based on query content
    setTimeout(() => {
      let response = '';

      if (query.toLowerCase().includes('pytorch') || query.toLowerCase().includes('torch')) {
        response = 'PyTorch is excellent for research and dynamic neural networks. Key advantages include eager execution, dynamic computational graphs, and strong community support. Ibrahim frequently uses it for LLM research!';
      } else if (query.toLowerCase().includes('career') || query.toLowerCase().includes('job')) {
        response = 'For ML engineering careers, focus on: 1) Strong programming fundamentals, 2) Mathematical foundation (linear algebra, statistics), 3) Practical project experience, 4) Understanding of MLOps and deployment. Ibrahim\'s journey shows the importance of continuous learning!';
      } else if (query.toLowerCase().includes('llm') || query.toLowerCase().includes('language model')) {
        response = 'Large Language Models are transforming AI! Key concepts: transformers, attention mechanisms, fine-tuning techniques like LoRA, and efficient inference methods. Ibrahim specializes in LLM optimization and novel architectures.';
      } else {
        response = 'That\'s an interesting question! Based on Ibrahim\'s experience in ML engineering, I\'d recommend breaking down complex problems into smaller components and always validating with real data. Feel free to ask more specific technical questions!';
      }

      addOutput('ai-response', `🤖 AI Assistant: ${response}`);
    }, 1500);
  };

  const getCommandSuggestions = (input) => {
    const commands = Object.keys(systemCommands);
    const allCommands = [...commands, 'dir', 'cls', 'type', 'more', 'edit', 'quit', 'exit', 'play', 'matrix', 'weather', 'crypto', 'music', 'social', 'monitor', 'alias', 'execute', 'ai', 'chat'];

    return allCommands.filter(cmd =>
      cmd.toLowerCase().includes(input.toLowerCase()) ||
      input.toLowerCase().includes(cmd.toLowerCase())
    ).slice(0, 3);
  };

  const handleLs = (directory) => {
    const currentDir = directory || currentPath;

    switch (currentDir) {
      case '/home/ibrahim':
      case '/':
        addOutput('output', 'Directories and Files:');
        addOutput('directory', '  📁 about/          - Personal information and bio');
        addOutput('directory', '  📁 projects/       - ML/AI project portfolio of on going and completed projects');
        addOutput('directory', '  📁 experience/     - Work, Research, and Teaching history, recommendations and skill growth ');
        addOutput('directory', '  📁 contact/        - Contact information and links');
        addOutput('directory', '  📁 achievements/   - Awards and leadership');
        addOutput('directory', '  📁 skills/         - Technical skills and expertise');
        // addOutput('directory', '  📁 research/       - Research papers and publications');
        // addOutput('directory', '  📁 blog/           - Technical articles and posts');
        // addOutput('file', '      📄 README.md       - Portfolio overview');
        addOutput('file', '      📄 resume.pdf      - Latest resume/CV');
        break;

      case '/about':
        addOutput('output', 'About directory contents:');
        addOutput('file', '  📄 bio.txt          - Personal biography');
        // addOutput('file', '  📄 README.md        - About section overview');  
        addOutput('file', '  📄 story.md         - My journey into ML/AI');
        addOutput('file', '  🎓 education.txt    - Educational background');
        addOutput('file', '  📄 philosophy.txt   - My approach to technology');
        addOutput('file', '  📄 interests.json   - Personal interests and hobbies');
        break;

      case '/projects':
        // addOutput('output', 'Project portfolio:');
        // Object.keys(projectsData).forEach(project => {
        //   const proj = projectsData[project];
        //   addOutput('project', `  🚀 ${project.padEnd(25)} - ${proj.name}`);
        // });
        addOutput('file', '  📄 ongoing.md         - List of all my current projects');
        addOutput('file', '  📄 completed.md         - List of all my completed projects');
        // addOutput('file', '  📄 README.md        - Projects overview');
        // addOutput('file', '  📄 portfolio.json   - Complete project metadata');
        break;

      case '/experience':
        addOutput('output', 'Experience directory:');
        addOutput('file', '  📄 work_research_timeline.json    - Complete work history');
        addOutput('file', '  📄 recommendations.md - LinkedIn recommendations');
        addOutput('file', '  📄 skills_growth.json - Skill development over time');
        addOutput('file', '  📄 teaching.json - Professional teaching experience of undergrad and master courses');
        // addOutput('file', '  📄 interviews.md    - Notable interview experiences');
        break;

      case '/contact':
        addOutput('output', 'Contact information:');
        addOutput('file', '  📧 email.txt        - Primary email contact');
        addOutput('file', '  🔗 social_links.json - All social media profiles');
        addOutput('file', '  📱 phone.txt        - Contact number (private)');
        addOutput('file', '  🌐 website.url      - Personal website');
        addOutput('file', '  📍 location.txt     - Current location');
        break;

      case '/achievements':
        addOutput('output', 'Achievements and recognition:');
        addOutput('file', '  🏆 awards.json      - Professional awards');
        // addOutput('file', '  📚 publications.bib - Research publications');
        // addOutput('file', '  🎓 education.txt    - Educational background');
        // addOutput('file', '  📜 certifications.json - Industry certifications');
        addOutput('file', '  🌟 highlights.md    - Career highlights');
        break;

      case '/skills':
        addOutput('output', 'Technical skills breakdown:');
        addOutput('file', '  💻 programming.json - Programming languages');
        addOutput('file', '  🧠 ml_frameworks.txt - ML/AI frameworks');
        addOutput('file', '  ☁️ cloud_tech.json  - Cloud technologies');
        addOutput('file', '  🛠️ tools.txt        - Development tools');
        addOutput('file', '  📊 databases.json   - Database technologies');
        break;

      case '/research':
        addOutput('output', 'Research and publications:');
        addOutput('file', '  📖 papers.bib       - Published research papers');
        addOutput('file', '  🔬 ongoing.md       - Current research projects');
        addOutput('file', '  📝 drafts/          - Work in progress papers');
        addOutput('file', '  👥 collaborations.json - Research collaborations');
        addOutput('file', '  📊 impact.txt       - Citation metrics');
        break;

      // case '/blog':
      //   addOutput('output', 'Blog posts and articles:');
      //   addOutput('file', '  ✍️ recent_posts.json - Latest blog entries');
      //   addOutput('file', '  🔥 popular.md       - Most viewed articles');
      //   addOutput('file', '  💡 tutorials/       - Technical tutorials');
      //   addOutput('file', '  📈 analytics.json   - Blog performance metrics');
      //   addOutput('file', '  🎯 topics.txt       - Covered topics list');
      //   break;

      default:
        addOutput('error', `Directory not found: ${directory}`);
        addOutput('hint', 'Use "ls" to see available directories');
    }
  };

  const handleCd = (directory) => {
    const validDirs = [
      '/', '/home', '/home/ibrahim',
      '/about', '/projects', '/experience', '/contact',
      '/achievements', '/skills', '/research', '/blog'
    ];

    if (!directory || directory === '~') {
      setCurrentPath('/home/ibrahim');
      addOutput('output', 'Moved to home directory');
    } else if (validDirs.includes(directory)) {
      setCurrentPath(directory);
      addOutput('output', `Moved to ${directory}`);
    } else {
      addOutput('error', `Directory not found: ${directory}`);
      addOutput('hint', 'Use "ls" to see available directories');
    }
  };

  const handleCat = (file) => {
    if (!file) {
      addOutput('error', 'Please specify a file to display');
      addOutput('example', 'Example: cat about.txt, cat bio.txt, cat resume.pdf');
      return;
    }

    // Handle files based on current path and file name
    const fileName = file.toLowerCase();

    switch (fileName) {
      // About directory files
      case 'bio.txt':
      case 'about.txt':
        addOutput('file-header', '=== PERSONAL BIOGRAPHY ===');
        addOutput('output', '');
        addOutput('output', `Name: ${profileData.name}`);
        addOutput('output', `Role: ${profileData.tagline}`);
        addOutput('output', `Location: ${profileData.location}`);
        addOutput('output', '');
        addOutput('output', 'ABOUT ME:');
        addOutput('output', 'I am a Computer Science graduate from LUMS (Minor in Computational Finance), now pursuing my MS in Computer Science at Dartmouth College.');
        addOutput('output', 'I am passionate about leveraging AI and machine learning to solve real-world problems, with research spanning multi-agent systems, NLP, and retrieval-augmented generation.');
        addOutput('output', '');
        addOutput('output', 'BACKGROUND:');
        addOutput('output', '• Research Assistant at CITY: Multi-agent robotic systems using LLMs for warehouse navigation');
        addOutput('output', '• Research Assistant at CSaLT: NLP-driven tweet classification for political discourse analysis');
        addOutput('output', '• Senior Tech Officer at AMW International: Built centralized databases, digitized workflows, optimized operations, and trained staff on custom tools');
        addOutput('output', '• President of SPADES (LUMS): Led AI education, STEM outreach, and Pakistan’s flagship science Olympiad PSIFI');
        addOutput('output', '• Strong academic background: GPA 3.99/4.00, top 2% of class at LUMS');
        addOutput('output', '');
        addOutput('output', 'SKILLS:');
        addOutput('output', '• Python, PyTorch, LangChain, Full-stack development');
        addOutput('output', '• Machine learning (model compression, domain generalization, RAG)');
        addOutput('output', '• Data systems, workflow optimization, and applied AI solutions');
        addOutput('output', '');
        addOutput('output', 'PASSION PROJECTS:');
        addOutput('output', '• Building intelligent systems at the intersection of AI research and real-world applications');
        addOutput('output', '• Promoting AI education and accessibility for underserved communities');
        addOutput('output', '• Leadership in STEM education, outreach, and social responsibility');
        break;


      case 'story.md':
        addOutput('file-header', '=== FROM HUMBLE BEGINNINGS TO NEW HORIZONS ===');
        addOutput('output', '');

        addOutput('output', 'THE EARLY YEARS:');
        addOutput('output', 'I spent my high school years at Aitchison, often keeping to myself. I was not');
        addOutput('output', 'the loudest voice in the room, nor the most confident on the big stage. But I');
        addOutput('output', 'learned the value of discipline, consistency, and quiet determination.');
        addOutput('output', '');

        addOutput('output', 'LUMS — A TURNING POINT:');
        addOutput('output', 'Earning a scholarship to study Computer Science at LUMS transformed me. It was');
        addOutput('output', 'here that I stepped out of my comfort zone, grew as a leader, and discovered my');
        addOutput('output', 'true passion for Machine Learning and Artificial Intelligence. These years taught');
        addOutput('output', 'me that persistence and hard work can open doors I once thought were closed.');
        addOutput('output', '');

        addOutput('output', 'DARTMOUTH — A NEW CHAPTER:');
        addOutput('output', 'Now, I am humbled to be continuing my journey at Dartmouth College as a Master\'s');
        addOutput('output', 'student in Computer Science. Being the first in my family — both close and extended —');
        addOutput('output', 'to attend an Ivy League institution, and doing so on scholarship, is not just a');
        addOutput('output', 'personal milestone but also a reflection of the sacrifices, guidance, and support');
        addOutput('output', 'that shaped me.');
        addOutput('output', '');

        addOutput('output', 'MY MISSION:');
        addOutput('output', 'My work in ML and AI is fueled by a vision beyond research papers and labs. I want');
        addOutput('output', 'to build tools that make advanced technology accessible to those who do not have the');
        addOutput('output', 'same resources and opportunities. For me, success is not measured by where I stand,');
        addOutput('output', 'but by how many others I can help bring onto the same stage.');
        break;


      case 'philosophy.txt':
        addOutput('file-header', '=== TECHNOLOGY PHILOSOPHY ===');
        addOutput('output', '');
        addOutput('output', 'CORE BELIEFS:');
        addOutput('output', '');
        addOutput('output', '1. AI should augment human intelligence, not replace it');
        addOutput('output', '2. Ethical AI development is not optional, it\'s essential');
        addOutput('output', '3. Open science accelerates progress for everyone');
        addOutput('output', '4. Simplicity in complex systems is the ultimate sophistication');
        addOutput('output', '5. Continuous learning is the only way to stay relevant');
        addOutput('output', '');
        addOutput('output', 'APPROACH TO PROBLEM SOLVING:');
        addOutput('output', '• Start with the data, let it guide the solution');
        addOutput('output', '• Iterate fast, fail fast, learn faster');
        addOutput('output', '• Measure everything, optimize what matters');
        addOutput('output', '• Collaborate openly, share knowledge freely');
        break;

      case 'interests.json':
        addOutput('file-header', '=== PERSONAL INTERESTS ===');
        addOutput('output', '');
        addOutput('output', '💪 Used to be a big gym enthusiast — slowly getting back into it. I jog a lot these days; fun fact: during my senior spring I clocked 2km in 10 minutes (huge achievement for me 🚀).');
        addOutput('output', '');
        addOutput('output', '⚽ Massive football fan! Playing Fantasy Premier League this season, but with a twist — everything is data-driven 📊 (yes, I’ve built ML models to optimize my picks).');
        addOutput('output', '');
        addOutput('output', '🎾 Big tennis follower — Alcaraz is my current favorite, but Federer will always be the 🐐. Still learning how to actually play, so if you can teach me, I’m all in!');
        addOutput('output', '');
        addOutput('output', '❤️ Sports loyalty runs deep: Manchester United in football, Pakistan in cricket. If you know, you know… it’s been a rollercoaster ride 😅.');
        break;

      // achievements files
      case 'awards.json':
        addOutput('file-header', '=== ACHIEVEMENTS & AWARDS ===');
        addOutput('output', '');

        achievementsData.forEach((item) => {
          addOutput(
            'output',
            `🏆 <strong>${item.title}</strong> [${item.type}]<br/>
            ${item.description}<br/>
            <em>${new Date(item.startDate).toLocaleDateString()} - ${new Date(item.endDate).toLocaleDateString()}</em>`
          );
          addOutput('output', ''); // spacing between entries
        });

        break;

      case 'education.txt':
        addOutput('file-header', '=== EDUCATION ===');
        addOutput('output', '');

        addOutput(
          'output',
          `🏫 <strong>Aitchison College</strong> (2010 – 2021)<br/>
          • Secured 7 A* and 2 A in O-Levels<br/>
          • Achieved 4 A* in A-Levels (Further Mathematics, Physics, Mathematics, Computer Science)`
        );
        addOutput('output', '');

        addOutput(
          'output',
          `🎓 <strong>BS Computer Science – LUMS</strong> (Sep 2021 – May 2025)<br/>
          • GPA: 3.99/4.00 (Top 1% in a batch of 1,500+ students)<br/>
          • Minor: Computational Finance<br/>
          • Awarded a full merit scholarship for all 4 years`
        );
        addOutput('output', '');

        addOutput(
          'output',
          `🎓 <strong>MS Computer Science – Dartmouth College</strong> (Sep 2025 – Jun 2027)<br/>
          • Focus: Advanced AI & Machine Learning<br/>
          • Awarded a full scholarship for the entire program`
        );
        addOutput('output', '');

        break;

      case 'highlights.md':
        addOutput('file-header', '=== LEADERSHIP & COMMUNITY HIGHLIGHTS ===');
        addOutput('output', '');

        // SPADES – President
        addOutput(
          'output',
          `SPADES (Society for Promotion & Development of Engineering and Sciences)\n` +
          `>> President | May 2024 – May 2025\n\n` +
          `   • Led 350+ members, expanding into AI, aerospace & outreach\n` +
          `   • Grew funds $2420 → $25000\n` +
          `   • Directed PSIFI (350+ teams, 1500 participants, PKR 16M revenue)\n` +
          `   • Launched Pakistan’s first student rocketry project (target: intl. 2027)\n` +
          `   • Hosted NASA engineer talk on James Webb Telescope (300+ attendees)\n` +
          `   • Organized rural coding/math outreach (100+ students, +60% perf.)\n` +
          `   • Science symposium (500+ participants, $3000 raised)\n` +
          `   • Partnered with UPLIFT AI (guided 33 interns on RAG, LLMs, inclusive AI)\n` +
          `   • Women in STEM campaign: workshops, mentorship, partnerships\n` +
          `   • Awards: Leadership Excellence | Mega Event Excellence`
        );
        addOutput('output', '\n--------------------------------------------------\n');

        // SPADES – Convenor
        addOutput(
          'output',
          `SPADES (Flagship Event – PSIFI)\n` +
          `>> Convenor | May 2023 – Apr 2024\n\n` +
          `   • Directed Pakistan’s largest science olympiad (1000+ participants)\n` +
          `   • Introduced HACKX coding comp. (50+ teams, 25+ universities)\n` +
          `   • Raised $26000 in revenue → $10000 profit resulting in most profitable PSIFI\n` +
          `   • Enabled 50+ underserved students to attend free`
        );
        addOutput('output', '\n--------------------------------------------------\n');

        // Peer Ambassador
        addOutput(
          'output',
          `Peer Ambassador for Social Support (PALss)\n` +
          `>> Mentor | Aug 2024 – May 2025\n\n` +
          `   • Mentored 42+ new students via 1:1 & group sessions\n` +
          `   • Helped address stress, homesickness & time management\n` +
          `   • 80% of mentees joined societies & built strong peer networks\n` +
          `   • Supported vulnerable students with tailored guidance`
        );
        addOutput('output', '');

        break;


      // project files
      case "ongoing.md":
        addOutput("file-header", "=== 📂 ONGOING PROJECTS ===");

        ongoingproj.forEach((proj, index) => {
          addOutput("output", `\n${index + 1}. ${proj.title}`);
          addOutput("output", `📝 ${proj.desc}`);
          if (proj.techStack && proj.techStack.length > 0) {
            addOutput("output", `⚙️ Tech Stack: ${proj.techStack.join(", ")}`);
          }
          if (proj.highlight) {
            addOutput("output", `✨ Highlight: ${proj.highlight}`);
          }
          if (proj.link) {
            addOutput(
              "output",
              <a
                href={proj.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#4ADE80" }}
              >
                🔗 {proj.link === "Coming Soon" ? "Coming Soon" : "View Project"}
              </a>
            );
          }
        });
        break;

      case "completed.md":
        addOutput("file-header", "=== 📂 Completed PROJECTS ===");

        completedprojs.forEach((proj, index) => {
          addOutput("output", `\n${index + 1}. ${proj.title}`);
          addOutput("output", `📝 ${proj.desc}`);
          if (proj.techStack && proj.techStack.length > 0) {
            addOutput("output", `⚙️ Tech Stack: ${proj.techStack.join(", ")}`);
          }
          if (proj.highlight) {
            addOutput("output", `✨ Highlight: ${proj.highlight}`);
          }
          if (proj.link) {
            addOutput(
              "output",
              <a
                href={proj.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#4ADE80" }}
              >
                🔗 {proj.link === "Coming Soon" ? "Coming Soon" : "View Project"}
              </a>
            );
          }
        });
        break;



      




      // Experience files
      case 'work_research_timeline.json':
  addOutput('file-header', '=== CAREER TIMELINE ===');
  addOutput('output', '');
  experienceData.forEach((exp, index) => {
    // Main entry
    addOutput('timeline-entry', `${exp.period}: ${exp.title} @ ${exp.company}`);
    addOutput('output', `Location: ${exp.location}`);
    addOutput('output', `${exp.description}`);
    
    // Achievements
    addOutput('output', 'Key Achievements:');
    exp.achievements.forEach(achievement => {
      addOutput('output', `  • ${achievement}`);
    });

    
    if (exp.link) {
      // addOutput('output', `🔗 Link: ${exp.link}`);
      // OR if your terminal renderer supports HTML:
      addOutput('output', `🔗 Link: <a href="${exp.link}" target="_blank">${exp.link}</a>`);
    }

    if (index < experienceData.length - 1) addOutput('output', '');
  });
  break;


      case 'recommendations.md':
        addOutput('file-header', '=== OVERALL RECOMMENDATIONS ===');
        addOutput('output', '');

        addOutput('recommendation', '"Ibrahim stands out as an exceptional leader and scholar. He has consistently demonstrated maturity, responsibility, and initiative in every role he has taken on.');
        addOutput('recommendation', 'His leadership within the student community was exemplary, and I was proud to nominate him as the only student from the School of Science for the valedictorian shortlist, among 1,500 peers in his batch.');
        addOutput('recommendation', 'He is a role model for his fellow students and a true asset to our academic community."');
        addOutput('output', '— Dr. Walther, Dean of SSE, LUMS');

        addOutput('output', '');
        // Faculty Recommendations
        addOutput('recommendation', '"Ibrahim has been one of the most reliable and talented teaching assistants I have worked with.');
        addOutput('recommendation', 'He assisted me in three courses, including Machine Learning and Applied Probability, and consistently demonstrated deep technical understanding,');
        addOutput('recommendation', 'a strong work ethic, and an ability to connect with students. He is not only an excellent engineer but also a natural mentor."');
        addOutput('output', '— Dr. Momin Uppal, Professor of Electrical Engineering, LUMS');

        addOutput('output', '');
        addOutput('recommendation', '"Ibrahim has collaborated with me on two major research projects, where he impressed me with his creativity, research acumen, and persistence.');
        addOutput('recommendation', 'He has the rare ability to dive into challenging problems, propose innovative solutions, and see them through to implementation.');
        addOutput('recommendation', 'His contributions to our projects were crucial, and I look forward to following his future success."');
        addOutput('output', '— Dr. Tahir, Associate Professor, LUMS');

        addOutput('output', '');

        // Society Feedback (Peers & Juniors)
        addOutput('recommendation', '"Thank you so much for everything! It has been an honor to work under your leadership.');
        addOutput('recommendation', 'If someone asked me which senior I will miss the most from my time at LUMS, it would undoubtedly be you.');
        addOutput('recommendation', 'You have been a mentor to me in so many ways that you may not even realize. You inspired me, the people around you,');
        addOutput('recommendation', 'and the entire society. Your support means the world. Grateful to also have you as a TA — always a king, always inspiring."');
        addOutput('output', '— Society Member');

        addOutput('output', '');
        addOutput('recommendation', '"I would not have had nearly as much fun at LUMS without your leadership.');
        addOutput('recommendation', 'You made the society such a wholesome and welcoming place, despite the chaos, stress, and late all-nighters.');
        addOutput('recommendation', 'Thank you for making it all worth it."');
        addOutput('output', '— Society Member');

        addOutput('output', '');
        addOutput('recommendation', '"Boss man, it’s all thanks to you. We probably could not have achieved half of what we did without your guidance and leadership.');
        addOutput('recommendation', 'You’ve been a constant source of inspiration, guidance, and motivation — not only as a leader, but also as a senior and a friend."');
        addOutput('output', '— Society Member');

        break;

      case 'skills_growth.json':
        addOutput('file-header', '=== Skills Growth ===');
        addOutput('output', '');
        addOutput('skill-category', 'EXPERT LEVEL:');
        addOutput('output', '  • Python - Primary language for ML/AI development');
        addOutput('output', '  • SQL - Advanced database queries and optimization');
        addOutput('output', '  • Bash/Shell Scripting - Automation and DevOps tasks');
        addOutput('output', '  • C++ - Performance-critical applications');
        addOutput('output', '');
        addOutput('skill-category', 'PROFICIENT LEVEL:');
        addOutput('output', '  • JavaScript/TypeScript - Full-stack web development');
        addOutput('output', '  • R - Statistical analysis and data science');
        addOutput('output', '  • HTML/CSS - Frontend design and development');
        addOutput('output', '  • C# - Enterprise applications and tooling');
        addOutput('output', '');
        addOutput('skill-category', 'WORKING KNOWLEDGE:');
        addOutput('output', '  • Go - Backend services and microservices');
        addOutput('output', '  • Rust - System programming and performance optimization');
        addOutput('output', '  • Java - General-purpose applications');
        addOutput('output', '  • Julia - High-performance scientific computing');
        break;

case 'teaching.json':
  addOutput('file-header', '=== TEACHING EXPERIENCE ===');

  teachingExperience.forEach((exp, index) => {
    const bullets = exp.description
      .split('. ')
      .filter(Boolean)
      .map((line) => `• ${line.trim().replace(/\.$/, '')}.`);

    addOutput(
      'output',
      `📌 ${exp.title}
🏛️ ${exp.University}
📅 ${exp.period}
📍 ${exp.location}

${bullets.join('\n')}

`
    );
  });
  break;






      // Contact files
      case 'email.txt':
        addOutput('file-header', '=== CONTACT INFORMATION ===');
        addOutput('output', '');
        addOutput('output', `Primary Email: ${profileData.email}`);
        addOutput('output', 'Response Time: Usually within 24 hours');
        addOutput('output', 'Best For: Professional inquiries, collaboration opportunities');
        addOutput('output', '');
        addOutput('output', 'PREFERRED CONTACT METHODS:');
        addOutput('output', '1. Email - For detailed discussions');
        addOutput('output', '2. LinkedIn - For networking');
        addOutput('output', '3. GitHub - For technical collaboration');
        break;

      case 'social_links.json':
        addOutput('file-header', '=== SOCIAL MEDIA PROFILES ===');
        addOutput('output', '');

        addOutput(
          'output',
          `🔗 GitHub: <a href="https://github.com/fireblaster000" target="_blank">https://github.com/fireblaster000</a>`
        );

        addOutput(
          'output',
          `💼 LinkedIn: <a href="https://www.linkedin.com/in/muhammad-ibrahim-farrukh" target="_blank">https://www.linkedin.com/in/muhammad-ibrahim-farrukh</a>`
        );

        addOutput(
          'output',
          `📧 Email: <a href="mailto:ibrahimfarrukh000@gmail.com">ibrahimfarrukh000@gmail.com</a>`
        );
        break;





      case 'phone.txt':
        addOutput('file-header', '=== PHONE CONTACT ===');
        addOutput('output', '');
        addOutput('output', 'Phone Number: (Private - Available upon request)');
        addOutput('output', 'Best Time to Call: Weekdays after 5 PM (GMT+7)');
        addOutput('output', 'Preferred Method: Text or WhatsApp for initial contact');
        break;

      case 'website.url':
        addOutput('file-header', '=== PERSONAL WEBSITE ===');
        addOutput('output', '');
        //add you are already exploring it and tell them what they can find there, dont add url. add detailed info
        addOutput('output', 'You are already exploring it! Here, you can find a comprehensive overview of my professional journey, including:');
        addOutput('output', '• Detailed project portfolio showcasing my work in machine learning and AI');
        addOutput('output', '• Contact information for professional inquiries');
        addOutput('output', 'Feel free to navigate through the various sections to learn more about my skills, experience, and interests.');
        break;

      case 'location.txt':
        addOutput('file-header', '=== CURRENT LOCATION ===');
        addOutput('output', '');
        addOutput('output', `Location: ${profileData.location}`);
        addOutput('output', 'Timezone: GMT+7 (Dartmouth College)');
        addOutput('output', 'Willing to Relocate: Yes, for the right opportunity');
        addOutput('output', '');
        addOutput('output', 'I am currently based in Hanover, NH, USA, pursuing my Master\'s in Computer Science at Dartmouth College.');
        addOutput('output', 'I am open to remote work and relocation for exciting opportunities in the field of AI and machine learning.');
        break;

      // Skills files
      case 'programming.json':
        addOutput('file-header', '=== PROGRAMMING LANGUAGES ===');
        addOutput('output', '');
        addOutput('skill-category', 'EXPERT LEVEL:');
        addOutput('output', '  • Python - Primary language for ML/AI development');
        addOutput('output', '  • SQL - Advanced database queries and optimization');
        addOutput('output', '  • Bash/Shell Scripting - Automation and DevOps tasks');
        addOutput('output', '  • C++ - Performance-critical applications');
        addOutput('output', '');
        addOutput('skill-category', 'PROFICIENT LEVEL:');
        addOutput('output', '  • JavaScript/TypeScript - Full-stack web development');
        addOutput('output', '  • R - Statistical analysis and data science');
        addOutput('output', '  • HTML/CSS - Frontend design and development');
        addOutput('output', '  • C# - Enterprise applications and tooling');
        addOutput('output', '');
        addOutput('skill-category', 'WORKING KNOWLEDGE:');
        addOutput('output', '  • Go - Backend services and microservices');
        addOutput('output', '  • Rust - System programming and performance optimization');
        addOutput('output', '  • Java - General-purpose applications');
        addOutput('output', '  • Julia - High-performance scientific computing');
        break;

      case 'ml_frameworks.txt':
        addOutput('file-header', '=== ML/AI FRAMEWORKS & LIBRARIES ===');
        addOutput('output', '');
        addOutput('framework-expert', 'DEEP LEARNING FRAMEWORKS:');
        addOutput('output', '  🔥 PyTorch - Primary framework, including Lightning');
        addOutput('output', '  🧠 TensorFlow - Including TF Serving and TensorBoard');
        addOutput('output', '  🤗 Transformers - HuggingFace library expert');
        addOutput('output', '  🚀 ONNX - Model interoperability and optimization');
        addOutput('output', '  ⚡ FastAPI - High-performance APIs for ML models');
        addOutput('output', '');
        addOutput('framework-expert', 'TRADITIONAL ML:');
        addOutput('output', '  📊 Scikit-learn - Classical ML algorithms');
        addOutput('output', '  ⚡ XGBoost - Gradient boosting for structured data');
        addOutput('output', '  🌟 LightGBM - Fast gradient boosting framework');
        addOutput('output', '');
        addOutput('framework-expert', 'SPECIALIZED LIBRARIES:');
        addOutput('output', '  🔍 FAISS - Similarity search and clustering');
        addOutput('output', '  📝 spaCy - Industrial-strength NLP');
        addOutput('output', '  👁️ OpenCV - Computer vision tasks');
        break;

      case 'tools.txt':
        addOutput('file-header', '=== DEV TOOLS & UTILITIES ===');
        addOutput('output', '');

        addOutput('framework-expert', 'CODE & COLLABORATION:');
        addOutput('output', '  📝 VS Code - Primary editor with ML/AI extensions');
        addOutput('output', '  🧑‍🤝‍🧑 Git/GitHub - Version control & collaboration');
        addOutput('output', '  🌐 Jupyter/Colab - Interactive ML/DS notebooks');
        addOutput('output', '');

        addOutput('framework-expert', 'PRODUCTIVITY & WORKFLOWS:');
        addOutput('output', '  ✅ Notion - Project & knowledge management');
        addOutput('output', '  📊 Excel/Google Sheets - Quick analysis & reporting');
        addOutput('output', '  ⏱️ Slack/Discord - Team comms & async collab');
        addOutput('output', '');

        addOutput('framework-expert', 'DATA & VISUALIZATION:');
        addOutput('output', '  📈 Matplotlib / Plotly - Data viz & dashboards');
        addOutput('output', '  🔍 Tableau - BI dashboards & storytelling');
        addOutput('output', '  🧩 PowerBI - Enterprise-scale data visualization');
        break;

      case 'cloud_tech.json':
        addOutput('file-header', '=== CLOUD & DEVOPS TECHNOLOGIES ===');
        addOutput('output', '');

        addOutput('framework-expert', 'CLOUD PROVIDERS:');
        addOutput('output', '  ☁️ AWS - EC2, S3, Lambda, DynamoDB, SageMaker');
        addOutput('output', '  🔵 Azure - Azure ML, Functions, CosmosDB');
        addOutput('output', '  🟢 GCP - GKE, BigQuery, Vertex AI');
        addOutput('output', '');

        addOutput('framework-expert', 'CONTAINERIZATION & ORCHESTRATION:');
        addOutput('output', '  🐳 Docker - Containerization for apps & ML pipelines');
        addOutput('output', '  ☸️ Kubernetes - Cluster orchestration, scaling, deployments');
        addOutput('output', '  📦 Helm - Package manager for Kubernetes configs');
        addOutput('output', '');

        addOutput('framework-expert', 'CI/CD & INFRASTRUCTURE:');
        addOutput('output', '  🔄 GitHub Actions - Automated workflows & CI/CD');
        addOutput('output', '  🚀 Jenkins - Build & deployment automation');
        // addOutput('output', '  🛠️ Terraform - Infrastructure as Code (IaC)');
        break;

      case 'databases.json':
        addOutput('file-header', '=== DATABASES & DATA STORES ===');
        addOutput('output', '');

        addOutput('framework-expert', 'RELATIONAL DATABASES:');
        addOutput('output', '  🐘 PostgreSQL - Advanced RDBMS, indexing & optimization');
        addOutput('output', '  🐬 MySQL - Widely used, production-grade relational DB');
        addOutput('output', '  🗂️ SQLite - Lightweight embedded database for apps');
        addOutput('output', '');

        addOutput('framework-expert', 'NOSQL DATABASES:');
        addOutput('output', '  🍃 MongoDB - Document-oriented DB, flexible schema');
        addOutput('output', '  ⚡ Redis - In-memory key-value store for caching & queues');
        addOutput('output', '  🔑 DynamoDB - AWS NoSQL DB, scalable & managed');
        addOutput('output', '');

        addOutput('framework-expert', 'DATA WAREHOUSING / BIG DATA:');
        addOutput('output', '  🏢 Snowflake - Cloud-native data warehouse');
        // addOutput('output', '  📈 BigQuery - Google-scale analytics engine');
        // addOutput('output', '  🐘 Hadoop/HDFS - Distributed storage & processing');
        break;






      // Research files
      // case 'papers.bib':
      //   addOutput('file-header', '=== RESEARCH PUBLICATIONS ===');
      //   addOutput('output', '');
      //   achievementsData.filter(a => a.type === 'RESEARCH' || a.type === 'PUBLICATION').forEach(paper => {
      //     addOutput('paper-title', paper.title);
      //     addOutput('output', `Description: ${paper.description}`);
      //     addOutput('output', `Date: ${paper.date}`);
      //     addOutput('output', `Link: ${paper.link}`);
      //     addOutput('output', '');
      //   });
      //   break;

      case 'ongoing.md':
        addOutput('file-header', '=== CURRENT RESEARCH PROJECTS ===');
        addOutput('output', '');
        addOutput('research-project', '1. AI Industry Pulse Dashboard');
        addOutput('output', '   LLM powered real-time analysis of AI trends and news using AI Agents');
        addOutput('output', '   Status: Blogging Agent prototype in development');
        addOutput('output', '');
        addOutput('research-project', '2. Fantasy Premier League AI Coach anf ML Predictions');
        addOutput('output', '   Team and player performance predictions using ML and LLMs');
        addOutput('output', '   Status: GW2 predictions and analysis ongoing');
        addOutput('output', '   Github: https://github.com/fireblaster000/Fantasy-Premier-League-ML-predictor');
        addOutput('output', '');
        addOutput('research-project', '3. Trading Platform using web sockets and LLM insights');
        addOutput('output', '   Real-time trading platform with LLM-driven market analysis');
        addOutput('output', '   Status: JWT authentication and basic trading features implemented');
        addOutput('output', '   Github: https://github.com/fireblaster000/Trading_App_firstwebsite');
        addOutput('output', '');
        break;

      // Resume and README
      // case 'resume.pdf':
      // case 'resume.txt':
      //   addOutput('file-header', '=== MUHAMMAD IBRAHIM FARRUKH - RESUME ===');
      //   addOutput('output', '');
      //   addOutput('resume-section', 'CONTACT INFORMATION:');
      //   addOutput('output', `Email: ${profileData.email}`);
      //   addOutput('output', `GitHub: ${profileData.github}`);
      //   addOutput('output', `LinkedIn: ${profileData.linkedin}`);
      //   addOutput('output', `Location: ${profileData.location}`);
      //   addOutput('output', '');
      //   addOutput('resume-section', 'PROFESSIONAL EXPERIENCE:');
      //   experienceData.forEach((exp, index) => {
      //     addOutput('output', `${exp.title} @ ${exp.company} (${exp.period})`);
      //     addOutput('output', `📍 ${exp.location}`);
      //     addOutput('output', `${exp.description}`);
      //     addOutput('output', '');
      //   });
      //   break;

      case 'resume':
case 'resume.pdf':
case 'resume.txt':
  addOutput('file-header', '=== MUHAMMAD IBRAHIM FARRUKH - RESUME ===');
  addOutput('output', '📄 Opening resume...\n');
  addOutput(
    'output',
    '🔗 View here: ',
  );
  addOutput(
    'output',
    <a 
      href="/IbrahimFarrukh_resume.pdf" 
      target="_blank" 
      rel="noopener noreferrer"
      style={{ color: '#4ADE80' }}
    >
      IbrahimFarrukh_resume.pdf
    </a>
  );
  break;



      case 'readme.md':
        addOutput('file-header', '=== PORTFOLIO README ===');
        addOutput('output', '');
        addOutput('output', `# ${profileData.name} - ${profileData.tagline}`);
        addOutput('output', '');
        addOutput('output', 'Welcome to my interactive portfolio shell! This unique interface');
        addOutput('output', 'showcases my work in Applied Machine Learning and LLM research.');
        addOutput('output', '');
        addOutput('output', '## Quick Navigation:');
        addOutput('output', '- `cd /projects` - View my ML/AI project portfolio');
        addOutput('output', '- `cd /Workexperience` - Explore my professional background');
        addOutput('output', '- `cd /Teachingexperience` - Check out my teaching experience');
        addOutput('output', '- `cd /LeaderShipexperience` - Check out my teaching experience');
        addOutput('output', '- `cat bio.txt` - Read my personal biography');
        addOutput('output', '- `cat resume.pdf` - View my latest resume/CV');
        addOutput('output', '- `theme <name>` - Switch between visual themes');
        addOutput('output', '- `play <game>` - Try the built-in games');
        addOutput('output', '');
        addOutput('output', '## Features:');
        addOutput('output', '✅ Tab completion for all commands');
        addOutput('output', '✅ Command history navigation');
        addOutput('output', '✅ Multiple interactive themes');
        addOutput('output', '✅ Built-in games and easter eggs');
        addOutput('output', '✅ Comprehensive project showcase');
        break;

      // Project files
      default:
        if (projectsData[fileName] || projectsData[fileName.replace('.md', '')]) {
          const project = projectsData[fileName] || projectsData[fileName.replace('.md', '')];
          addOutput('project-header', `=== ${project.name.toUpperCase()} ===`);
          addOutput('output', '');
          addOutput('output', `Description: ${project.description}`);
          addOutput('output', `Status: ${project.status}`);
          addOutput('output', `Technologies: ${project.tech.join(', ')}`);
          addOutput('output', '');
          addOutput('project-section', 'KEY FEATURES:');
          project.features.forEach(feature => {
            addOutput('output', `  ✅ ${feature}`);
          });
          addOutput('output', '');
          addOutput('project-section', 'LINKS:');
          addOutput('output', `🔗 GitHub: ${project.github}`);
          if (project.demo) {
            addOutput('output', `🌐 Demo: ${project.demo}`);
          }
        } else {
          addOutput('error', `File not found: ${file}`);
          addOutput('hint', 'Use "ls" to see available files in current directory');
          addOutput('example', 'Try: cat bio.txt, cat resume.pdf, or cat about.txt');
        }
    }
  };

  const handleWhoami = () => {
    addOutput('output', `${profileData.name}`);
    addOutput('output', `${profileData.tagline}`);
    addOutput('output', 'A human disguised as a machine learning wizard 🧙‍♂️');
    addOutput('output', `Currently located: ${profileData.location}`);
    addOutput('output', `Status: ${profileData.currentStatus}`);
  };

  const handleTheme = (themeName) => {
    if (!themeName) {
      addOutput('output', 'Available themes:');
      getThemeList().forEach(theme => {
        const indicator = theme.name === currentTheme ? ' (current)' : '';
        addOutput('output', `  ${theme.name} - ${theme.description}${indicator}`);
      });
      return;
    }

    if (changeTheme(themeName)) {
      addOutput('success', `Theme changed to: ${themeName}`);
    } else {
      addOutput('error', `Theme not found: ${themeName}`);
    }
  };

  const handleFortune = () => {
    const quote = fortuneQuotes[Math.floor(Math.random() * fortuneQuotes.length)];
    addOutput('fortune', quote);
  };

  const handleMotd = () => {
    const message = motdMessages[Math.floor(Math.random() * motdMessages.length)];
    addOutput('motd', message);
  };

  const handleAscii = (text) => {
    if (!text || text === 'ibrahim') {
      addOutput('ascii', '██╗██████╗ ██████╗  █████╗ ██╗  ██╗██╗███╗   ███╗');
      addOutput('ascii', '██║██╔══██╗██╔══██╗██╔══██╗██║  ██║██║████╗ ████║');
      addOutput('ascii', '██║██████╔╝██████╔╝███████║███████║██║██╔████╔██║');
      addOutput('ascii', '██║██╔══██╗██╔══██╗██╔══██║██╔══██║██║██║╚██╔╝██║');
      addOutput('ascii', '██║██████╔╝██║  ██║██║  ██║██║  ██║██║██║ ╚═╝ ██║');
      addOutput('ascii', '╚═╝╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝╚═╝     ╚═╝');
    } else {
      addOutput('output', `ASCII art for: ${text}`);
      addOutput('ascii', '┌─────────────────────────────┐');
      addOutput('ascii', `│  ${text.toUpperCase().padEnd(25)}  │`);
      addOutput('ascii', '└─────────────────────────────┘');
    }
  };

  const handleNano = (file) => {
    if (file === 'resume.txt' || file === 'resume') {
      addOutput('output', '┌── NANO EDITOR ──────────────────────────────────┐');
      addOutput('output', '│ Muhammad Ibrahim Farrukh                       │');
      addOutput('output', '│ Applied ML Engineer | LLMs Research            │');
      addOutput('output', '│                                                │');
      addOutput('output', '│ 📧 ibrahimfarrukh000@gmail.com                │');
      addOutput('output', '│ 🔗 github.com/fireblaster000                  │');
      addOutput('output', '│ 💼 linkedin.com/in/muhammad-ibrahim-farrukh/  │');
      addOutput('output', '│                                                │');
      addOutput('output', '│ Specializing in LLMs, PyTorch, TensorFlow     │');
      addOutput('output', '│ BSCS @ LUMS (Minor in Comp Finance)           │');
      addOutput('output', '│ MSCS @ Dartmouth                              │');
      addOutput('output', '└────────────────────────────────────────────────┘');
      addOutput('output', 'Press Ctrl+X to exit nano (simulated)');
    } else {
      addOutput('error', `Cannot open file: ${file}`);
    }
  };


  const handleSudo = (command) => {
    if (command.includes('hire ibrahim') || command.includes('hire')) {
      addOutput('success', '[sudo] Password accepted');
      addOutput('success', 'Initiating hire sequence...');
      addOutput('output', '> Compiling resume.pdf...');
      addOutput('output', '> Generating cover letter...');
      addOutput('output', '> Preparing portfolio showcase...');
      addOutput('success', '✅ Ready for interview! Contact: ibrahimfarrukh000@gmail.com');

      // Simulate resume download
      setTimeout(() => {
        const link = document.createElement('a');
        link.href = 'data:text/plain;charset=utf-8,Resume%20of%20Muhammad%20Ibrahim%20Farrukh';
        link.download = 'Ibrahim_Farrukh_Resume.txt';
        link.click();
      }, 1000);
    } else if (command.includes('rm -rf /')) {
      addOutput('humor', 'Nice try! But I like existing 😎');
      addOutput('humor', 'Detected attempt to delete universe. Permission denied.');
    } else if (command.includes('make coffee')) {
      addOutput('humor', 'Error: Coffee machine not found in PATH');
      addOutput('humor', 'Try: sudo apt-get install coffee-machine');
    } else {
      addOutput('error', `sudo: ${command}: command not found`);
    }
  };

  const handleGames = () => {
    addOutput('output', '🎮 IBRAHIM\'S ARCADE - Available Games:');
    addOutput('output', '');
    addOutput('game-option', '1. Snake          - Classic snake game with ML scoring');
    addOutput('game-option', '2. Pong           - Retro pong with AI opponent');
    addOutput('game-option', '3. Matrix Rain    - Interactive digital rain viewer');
    addOutput('game-option', '4. Typing Test    - Test your coding speed');
    addOutput('game-option', '5. Memory Game    - Remember the ML algorithm sequence');
    addOutput('output', '');
    addOutput('hint', 'Usage: play <game-name> (e.g., "play snake", "play pong")');
    addOutput('tip', '💡 Games are optimized for both desktop and mobile!');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      processCommand(input);
      setInput('');
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (commandHistory.length > 0) {
        const newIndex = historyIndex === -1 ? commandHistory.length - 1 : Math.max(0, historyIndex - 1);
        setHistoryIndex(newIndex);
        setInput(commandHistory[newIndex]);
      }
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (historyIndex !== -1) {
        const newIndex = Math.min(commandHistory.length - 1, historyIndex + 1);
        setHistoryIndex(newIndex === commandHistory.length - 1 ? -1 : newIndex);
        setInput(newIndex === -1 ? '' : commandHistory[newIndex]);
      }
    } else if (e.key === 'Tab') {
      e.preventDefault();
      handleTabCompletion();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      setInput('');
      addOutput('hint', 'Input cleared. Type "help" for available commands.');
    }
  };

  const handleTabCompletion = () => {
    const parts = input.split(' ');
    const commandPart = parts[0];
    const isCommandComplete = parts.length > 1;

    if (!isCommandComplete) {
      // Complete command names
      const allCommands = [
        ...Object.keys(systemCommands),
        'dir', 'cls', 'type', 'more', 'edit', 'quit', 'exit', 'history',
        'date', 'uptime', 'tree', 'find', 'grep', 'man', 'info', 'download'
      ];

      const matches = allCommands.filter(cmd =>
        cmd.toLowerCase().startsWith(commandPart.toLowerCase())
      );

      if (matches.length === 1) {
        setInput(matches[0] + ' ');
        addOutput('completion', `Completed: ${matches[0]}`);
      } else if (matches.length > 1) {
        addOutput('completion', `Possible completions (${matches.length}):`);
        addOutput('output', matches.join('  '));
        addOutput('hint', '💡 Type more characters to narrow down options');

        // Find common prefix
        const commonPrefix = findCommonPrefix(matches);
        if (commonPrefix.length > commandPart.length) {
          setInput(commonPrefix);
        }
      } else {
        addOutput('hint', 'No command completions available');
      }
    } else {
      // Complete arguments based on command
      handleArgumentCompletion(commandPart.toLowerCase(), parts.slice(1));
    }
  };

  const handleArgumentCompletion = (command, args) => {
    const currentArg = args[args.length - 1] || '';

    switch (command) {
      case 'cd':
        const directories = ['/home/ibrahim', '/about', '/projects', '/experience', '/contact', '/achievements', '/skills', '/research'];
        const dirMatches = directories.filter(dir =>
          dir.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('directories', dirMatches, currentArg, args);
        break;

      case 'cat':
      case 'type':
      case 'more':
        const files = [
          'about.txt', 'resume.txt', 'README.md', 'bio.txt',
          ...Object.keys(projectsData).map(p => p + '.md'),
          'contact.txt', 'skills.json', 'interests.json', 'philosophy.txt', 'story.md', 'work_research_timeline.json', 'recommendations.md', 'skills_growth.json', 'social_links.json', 'email.txt', 'website.url', 'location.txt', 'phone.txt', 'programming.json', 'ml_frameworks.txt', 'tools.txt', 'cloud_tech.json', 'databases.json', 'education.txt', 'highlights.md', 'awards.json', 'ongoing.md', 'completed.md','teaching.json',
        ];
        const fileMatches = files.filter(file =>
          file.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('files', fileMatches, currentArg, args);
        break;

      case 'theme':
        const themes = [
          'aurora', 'neon_synthwave', 'cosmic_void', 'digital_forest',
          'cyberpunk_city', 'quantum_realm', 'neural_network', 'matrix_reloaded',
          'sunset_gradient', 'holographic', 'minimal_zen', 'retro_terminal'
        ];
        const themeMatches = themes.filter(theme =>
          theme.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('themes', themeMatches, currentArg, args);
        break;

      case 'man':
      case 'help':
        const helpCommands = Object.keys(systemCommands);
        const helpMatches = helpCommands.filter(cmd =>
          cmd.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('commands', helpMatches, currentArg, args);
        break;

      case 'play':
        const games = ['snake', 'pong', 'matrix', 'typing', 'memory'];
        const gameMatches = games.filter(game =>
          game.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('games', gameMatches, currentArg, args);
        break;

      case 'weather':
        const cities = ['New York', 'London', 'Tokyo', 'San Francisco', 'Berlin', 'Current Location'];
        const cityMatches = cities.filter(city =>
          city.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('cities', cityMatches, currentArg, args);
        break;

      case 'crypto':
        const cryptos = ['bitcoin', 'ethereum', 'ai-token', 'ml-coin', 'neural-net', 'overview'];
        const cryptoMatches = cryptos.filter(crypto =>
          crypto.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('cryptocurrencies', cryptoMatches, currentArg, args);
        break;

      case 'music':
        const musicActions = ['play', 'pause', 'status', 'playlists'];
        const musicMatches = musicActions.filter(action =>
          action.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('music actions', musicMatches, currentArg, args);
        break;

      case 'download':
        const downloadOptions = ['cv', 'resume', 'projects', 'contact'];
        const downloadMatches = downloadOptions.filter(opt =>
          opt.toLowerCase().startsWith(currentArg.toLowerCase())
        );
        showCompletions('download options', downloadMatches, currentArg, args);
        break;

      case 'find':
      case 'grep':
        const searchSuggestions = ['machine learning', 'python', 'ai', 'research', 'ml', 'llm'];
        addOutput('hint', `💡 Search suggestions: ${searchSuggestions.join(', ')}`);
        break;

      default:
        addOutput('hint', `No completions available for "${command}" arguments`);
    }
  };

  const showCompletions = (type, matches, currentArg, args) => {
    if (matches.length === 1) {
      const newArgs = [...args.slice(0, -1), matches[0]];
      const parts = input.split(' ');
      setInput(parts[0] + ' ' + newArgs.join(' ') + ' ');
      addOutput('completion', `Completed: ${matches[0]}`);
    } else if (matches.length > 1) {
      addOutput('completion', `Available ${type} (${matches.length}):`);
      addOutput('output', matches.join('  '));

      // Find common prefix and update input
      const commonPrefix = findCommonPrefix(matches);
      if (commonPrefix.length > currentArg.length) {
        const newArgs = [...args.slice(0, -1), commonPrefix];
        const parts = input.split(' ');
        setInput(parts[0] + ' ' + newArgs.join(' '));
      }
    } else {
      addOutput('hint', `No ${type} match "${currentArg}"`);
    }
  };

  const findCommonPrefix = (strings) => {
    if (strings.length === 0) return '';
    if (strings.length === 1) return strings[0];

    let prefix = '';
    const firstString = strings[0].toLowerCase();

    for (let i = 0; i < firstString.length; i++) {
      const char = firstString[i];
      if (strings.every(str => str.toLowerCase()[i] === char)) {
        prefix += strings[0][i]; // Use original case from first string
      } else {
        break;
      }
    }

    return prefix;
  };

  return (
    <div className="terminal-container">
      {activeGame && (
        <GameEngine
          gameType={activeGame}
          onClose={() => setActiveGame(null)}
          addOutput={addOutput}
        />
      )}

      <div className="terminal-header">
        <div className="window-controls">
          <span className="control close"></span>
          <span className="control minimize"></span>
          <span className="control maximize"></span>
        </div>
        <div className="terminal-title">
          ibrahim@portfolio: {currentPath}
        </div>
        <div className="terminal-info">
          Theme: {currentTheme} | CPU: {systemStats.cpuUsage}% | RAM: {systemStats.memoryUsage}%
        </div>
      </div>

      <div className="terminal-body" ref={terminalRef}>
        <div className="terminal-output">
          {output.map((line, index) => (
            <div key={index} className={`output-line ${line.type}`}>
              {typeof line.content === "string" ? (
                <span dangerouslySetInnerHTML={{ __html: line.content }} />
              ) : (
                line.content
              )}
            </div>
          ))}
        </div>

        <div className="terminal-input-line">
          <span className="prompt">
            {currentPath}$
          </span>
          <input
            ref={inputRef}
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            className="terminal-input"
            autoFocus
            spellCheck={false}
          />
          <span className="cursor">█</span>
        </div>
      </div>

      <div className="terminal-footer">
        <div className="footer-info">
          Press TAB for autocomplete • ↑↓ for history • ESC to clear • Type "help" for commands
        </div>
      </div>
    </div>
  );
};

export default Terminal;